const translations = {
  pagination: {
    'text-actual-page': {
      en: 'Showing page {pageNumber}',
      da: 'Viser side {pageNumber}'
    },
    'button-prev-label': {
      en: 'Prev',
      da: 'Tidligere'
    },
    'button-prev-title': {
      en: 'Show the previous {rowsPerPage} rows',
      da: 'Vis de forrige {rowsPerPage} emner'
    },
    'button-next-label': {
      en: 'Next',
      da: 'Næste'
    },
    'button-next-title': {
      en: 'Show the next {rowsPerPage} rows',
      da: 'Vis de næste {rowsPerPage} emner'
    }
  },

  columnFilter: {
    'text-no-matching-option': {
      en: 'No {columnName} found',
      da: 'Ingen {columnName} fundet'
    },
    'button-opener-aria': {
      en: 'activate the {columnName} filter',
      da: 'aktiver {columnName} filteret'
    },
    'button-toggler-aria': {
      en: 'deactivate the {columnName} filter',
      da: 'deaktiver {columnName} filteret'
    }
  },

  tableBody: {
    'text-no-result': {
      en: 'No result',
      da: 'Intet resultat'
    }
  }
};

export { translations };